//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            id: this.$store.state.userInfo.id,
            usertype: 1,
            content: '',
            isempty: false
        }
    },
    methods: {
        isEmpty(content){
            if(content){
                this.isempty = false;
            }else{
                this.isEmpty = true;
            }
        },
        submitTick(){
            if(this.content == ''){
                this.isempty = true;
                this.$toastMsg('请填写您的问题');
                return;
            }
            let params = {
              person: this.$store.state.userInfo.id,
                usertype: 1,
                content: this.content
            };
            this.$doRequest("/api/feedbackinfo/insertSelective", params,res => {
              this.$toastMsg('反馈成功');
              this.$router.back(-1);
            })
        }
    },
    //生命周期之创建完成
    created: function(){
        document.title = '问题反馈';
        this.$isLogin(window.location.search.substr(1));

    },
}



// WEBPACK FOOTER //
// ./src/views/tickling/index.vue